var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 362,
    viewBox: "0 0 338 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.797 121.776H297.656L325.139 0H334.355L361.797 121.776Z",
    fill: "#FFDF53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.194 132.532L198.657 164.584L161.469 45.374L169.461 40.8125L254.194 132.532Z",
    fill: "#FFDF53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.419 195.582L134.328 251.094L42.5 166.42L47.1077 158.479L166.419 195.582Z",
    fill: "#FFDF53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.921 294.021V358.127L0 330.677V321.472L121.921 294.021Z",
    fill: "#FFDF53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight2);
export default __webpack_public_path__ + "static/media/light2.fd9ccb0ea0e3031c1a607459d39fb4b8.svg";
export { ForwardRef as ReactComponent };